import { useState } from 'react';

/**
 * Latches a boolean: false until `value` is first true, true forever after
 * (for the lifetime of the component instance).
 *
 * Use it to turn a "is the data present right now" flag into a "has the data
 * ever arrived" gate. A gate on the live flag unmounts whatever it guards if
 * the flag ever goes back to false — which, for a form, throws away what the
 * user has typed.
 *
 * Updated during render rather than in an effect, so the latched value is
 * correct in the same render the flag flips; this is the same previous-state
 * idiom `PatientDetailsDrawer` uses for `prevIsOpen`.
 */
export function useHasBeenTrue(value: boolean): boolean {
  const [hasBeenTrue, setHasBeenTrue] = useState(value);

  if (value && !hasBeenTrue) setHasBeenTrue(true);

  return hasBeenTrue;
}
